export const SET_ALL_EXPENSES = "SET_ALL_EXPENSES";
export const SET_EXPENSE_TYPE = 'SET_EXPENSE_TYPE';
export const RESET_CATEGORIES = "RESET_CATEGORIES";
export const SET_SPECIFIC_CATEGORIES = "SET_SPECIFIC_CATEGORIES";
export const RESET_SPECIFIC_CATEGORIES = "RESET_SPECIFIC_CATEGORIES";
export const SET_SUB_CATEGORIES = "SET_SUB_CATEGORIES";
export const RESET_SUB_CATEGORIES = "RESET_SUB_CATEGORIES";
export const SET_SPECIFIC_SUB_CATEGORIES = "SET_SPECIFIC_SUB_CATEGORIES";
export const RESET_SPECIFIC_SUB_CATEGORIES = "RESET_SPECIFIC_SUB_CATEGORIES";
